import { render } from "./Container.vue?vue&type=template&id=2153750e&scoped=true"
import script from "./Container.vue?vue&type=script&lang=js"
export * from "./Container.vue?vue&type=script&lang=js"

import "./Container.vue?vue&type=style&index=0&id=2153750e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2153750e"

export default script